/* Copyright (C) mroads, LLC - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Snigdha <snigdha.dhanireddy@mroads.com>, August 2020
 * @format
 * @flow
 */

import { ActionTypes } from '../constants';

export function updateMenu(menu: Object) {
  return {
    type: ActionTypes.MENU_UPDATE,
    payload: { menu },
  };
}

export function updateChecks(checks: Array<Object>) {
  return {
    type: ActionTypes.RETHINK_UPDATE_CHECKS,
    payload: { checks },
  };
}

export function clearChecks() {
  return {
    type: ActionTypes.RETHINK_CLEAR_CHECKS,
    payload: {},
  };
}

export function updateNotifications(notifications: Array<any>) {
  return {
    type: ActionTypes.RETHINK_UPDATE_NOTIFICATIONS,
    payload: { notifications },
  };
}

export function addLog(log: { logLevel: String, message: String }) {
  return {
    type: ActionTypes.RETHINK_ADD_LOG,
    payload: { log },
  };
}

export function clearLogs() {
  return {
    type: ActionTypes.RETHINK_CLEAR_LOGS,
    payload: {},
  };
}
